"use client";

import { Provider } from "react-redux";
import { store } from "../config/redux/store"; // adjust if your store path is different

export default function ReduxProvider({ children }) {
  return <Provider store={store}>{children}</Provider>;
}
